import React from 'react';

import { InputProps, TextField } from '@material-ui/core';

import { FadeInComponent } from '@/components/FadeInComponent';
import useDebouncedInputChange from '@/core/users/UserInvite/useDebouncedInputChange';
import { ReactComponent as WarningIcon } from '@/icons/warning.svg';

type Props = {
  emails: string;
  onChange: InputProps['onChange'];
  onBlur: InputProps['onBlur'];
  errorMessage?: string;
}
export function CommaSeparatedEmailsField ({ emails, errorMessage, onChange, onBlur }: Props) {
  const [value, onInputChange] = useDebouncedInputChange(onChange, emails);

  return (
    <div className="flex-grow pr-24 ml-6">
      <TextField
        placeholder="Enter email address(es) separated by commas"
        label="User email(s)"
        variant="outlined"
        className="w-full"
        value={value}
        error={!!errorMessage}
        onChange={onInputChange}
        onBlur={onBlur}
      />
      {errorMessage && (
        <FadeInComponent key={errorMessage} className="absolute mt-2">
          <div className="flex items-center py-3 pl-5 pr-8 text-sm font-light rounded bg-salmon-100 text-error">
            <WarningIcon className="w-4 h-4 mr-3" />
            {errorMessage}
          </div>
        </FadeInComponent>
      )}
    </div>
  );
}
